<div class="container">
  <img class="logo" src="assets\img\logo.png" />
  <p-panelMenu [model]="items"></p-panelMenu>
</div>
